import React from "react";
import SectionHeader, { CTABar } from "@/components/site/SectionHeader";
import { INDUSTRIES } from "@/components/site/content";

export default function IndustriesPage() {
  return (
    <div data-testid="industries-page">
      <section className="section-pad bg-white">
        <div className="container-tight">
          <SectionHeader overline="Industries We Serve" title="Depth across the sectors that power India." subtitle="Hiring frameworks and recruiter pods tuned to the pace and pressure of each industry." />
          <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {INDUSTRIES.map((ind, i) => (
              <div key={ind.name} data-testid={`industry-card-${i}`} className="group bg-secondary/50 rounded-2xl p-8 border border-border hover:bg-navy-800 hover:text-white transition-colors">
                <ind.icon size={32} weight="duotone" className="text-gold-500 group-hover:text-gold-400 transition-colors" />
                <h4 className="mt-6 font-serif text-xl">{ind.name}</h4>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABar
        title="Your industry, our recruiters."
        text="From logistics hubs to corporate offices, CRETRE builds workforce solutions that match your operating reality."
        primary={{ to: "/employers", label: "Discuss My Requirement" }}
        secondary={{ to: "/services", label: "See Services" }}
        testid="industries-cta-bar"
      />
    </div>
  );
}
